import { render, staticRenderFns } from "./BlockType108.vue?vue&type=template&id=289e94c2&scoped=true"
import script from "./BlockType108.vue?vue&type=script&lang=ts"
export * from "./BlockType108.vue?vue&type=script&lang=ts"
import style0 from "./BlockType108.vue?vue&type=style&index=0&id=289e94c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e94c2",
  null
  
)

export default component.exports